module.exports = __webpack_public_path__ + "1638a8e82f099cdb4dbca67bcef78cae.svg";